// extracted by mini-css-extract-plugin
export default {"button":"VendorStoreMenu_button__9TwT1","activeButton":"VendorStoreMenu_activeButton__uyqGu"};